var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-screen"},[_c('Stack',{attrs:{"justify":"center"}},[_c('LoadingIcon',{attrs:{"primary":"","size":"4"}}),_c('p',{staticStyle:{"text-align":"center"}},[_c('TextContent',[_vm._v("Loading ...")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }